var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChevronRightThinIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 32,
    glyphHeight: 59,
    glyphOffsetX: 4
  }), React.createElement("path", {
    d: "M3.32537 60.3317L0.238413 57.2344L27.0709 30.58L0.221357 3.94274L3.30633 0.843404L33.313 30.578L3.32537 60.3317Z"
  }));
};
export var ChevronRightThinIconGlyph = function (props) {
  return React.createElement(ChevronRightThinIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};